<template>
  <section class="b-miles-n-cash">
    <div class="b-miles-n-cash__header mb-24">
      <div class="b-miles-n-cash__header__title mb-8">
        <div class="left-side">
          <div class="new">{{ mbDictionary.milesNBonusTagLabel }}</div>
          <span>{{ mbDictionary.milesNCashLabel }}</span>
        </div>
        <LazyImage v-if="milesNBonusLogo" :image="milesNBonusLogo" />
      </div>
      <div v-if="milesNBonusLoggedIn" class="b-miles-n-cash__header__text bold">
        {{ mbDictionary.milesNCashHeaderText }}
      </div>
      <div v-else class="b-miles-n-cash__header__text bold">
        {{ mbDictionary.milesNCashGuestHeaderText }}
      </div>
    </div>
    <div v-if="milesNBonusLoggedIn" class="b-miles-n-cash__container">
      <div v-if="!redeemMilesEnabled" class="b-miles-n-cash__main">
        <div class="left">
          <div class="left-title">
            {{ mbDictionary.milesNCashDescriptionText }}
          </div>
          <div class="left-slider">
            <div class="b-miles-n-cash__slider">
              <button
                class="btn btn-clear minus"
                type="button"
                :disabled="sameMinMax"
                @click="sliderMinus">
                -
              </button>
              <VueSlider
                v-if="minValue >= 0 && maxValue > 0"
                v-model="selectedMiles"
                v-bind="sliderOptions"
                :min="minValue"
                :max="formatedMaxValue"
                :interval="interval"
                :tooltip-formatter="(val) => val.toLocaleString(lang)"
                @change="onChange" />
              <button
                class="btn btn-clear plus"
                type="button"
                :disabled="sameMinMax"
                @click="sliderPlus">
                +
              </button>
            </div>

            <div class="b-miles-n-cash__slider-minmax">
              <span>
                {{ minValue.toLocaleString(lang) }}
                {{ mbDictionary.milesNCashMinMaxSufix }}
              </span>
              <span>
                {{ formatedMaxValue.toLocaleString(lang) }}
                {{ mbDictionary.milesNCashMinMaxSufix }}
              </span>
            </div>
          </div>

          <div
            class="b-miles-n-cash__input"
            :style="[
              minimumMilesRule || maximumMilesRule
                ? { alignItems: 'flex-start' }
                : { alignItems: 'center' },
            ]">
            <label class="form-label">
              {{ mbDictionary.milesNCashInputMilesLabel }}
            </label>
            <div>
              <input
                id="inputMiles"
                :value="inputMiles"
                class="form-control"
                :class="{ 'has-error': minimumMilesRule || maximumMilesRule }"
                type="text"
                :disabled="sameMinMax" />
              <div v-if="minimumMilesRule" class="error">
                {{ mbDictionary.milesNCashMinimumMilesErrorText }}
                {{ minValue.toLocaleString(lang) }}
              </div>
              <div v-if="maximumMilesRule" class="error">
                {{ mbDictionary.milesNCashMaximumMilesErrorText }}
                {{ maxValue.toLocaleString(lang) }}
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <LazyImage v-if="cardImage" :image="cardImage" />
          <div class="d-flex flex-column">
            <span class="right-text">
              {{ mbDictionary.milesNBonusIDPrefix }}
            </span>
            <span class="right-id">
              {{ id }}
            </span>
          </div>
        </div>
      </div>

      <div v-else class="b-miles-n-cash__main b-miles-n-cash__main--thank-you">
        <div class="left">
          <span class="left-title">
            {{ mbDictionary.milesNCashThankYouTitle }}
          </span>
          <span class="left-text">
            {{ mbDictionary.milesNCashThankYouDescription }}
          </span>
        </div>
        <div class="right">
          <LazyImage v-if="cardImage" :image="cardImage" />
          <div class="d-flex flex-column">
            <span class="right-text">
              {{ mbDictionary.milesNBonusIDPrefix }}
            </span>
            <span class="right-id">
              {{ id }}
            </span>
          </div>
        </div>
      </div>

      <div class="form-separator"></div>

      <div class="b-miles-n-cash__footer">
        <button
          v-if="redeemMilesEnabled"
          class="btn btn-outline-primary"
          type="button"
          @click="onClickCancel">
          {{ mbDictionary.milesNCashChangeButtonText }}
        </button>
        <button
          v-else
          class="btn btn-primary"
          type="button"
          :disabled="minimumMilesRule || maximumMilesRule"
          @click="onClickSubmit">
          {{ mbDictionary.milesNCashRedeemButtonText }}
        </button>

        <div v-if="selectedMiles / rate > 0" class="table">
          <div>
            <span class="value extrabold">
              - €{{ discountAmount.toLocaleString(lang, formatOptions) }}
            </span>
            <span class="text">
              {{ mbDictionary.milesNCashDiscountAmountPrefix }}
              {{ selectedMiles.toLocaleString(lang) }}
              {{ mbDictionary.milesNCashDiscountAmountSufix }}
            </span>
          </div>
          <div>
            <span class="value extrabold">
              €{{ remainingAmount.toLocaleString(lang, formatOptions) }}
            </span>
            <span class="text">
              {{ mbDictionary.milesNCashRemainingAmountLabel }}
            </span>
          </div>
        </div>
      </div>

      <div class="b-miles-n-cash__bottom-line"></div>
    </div>
    <div
      v-else
      class="b-miles-n-cash__container b-miles-n-cash__container--guest">
      <button class="btn btn-primary" type="button" @click="showLoginModal">
        {{ mbDictionary.milesNCashGuestButtonText }}
      </button>
    </div>
  </section>
</template>

<script>
import * as lib from '../../lib/lib'
import LazyImage from './common/LazyImage.vue'
import VueSlider from 'vue-slider-component'
import Cleave from 'cleave.js'

export default {
  components: {
    LazyImage,
    VueSlider,
  },
  props: {
    totalCost: {
      required: true,
      type: Number,
    },
  },
  emits: ['has-balance-due'],
  data() {
    return {
      // ====== typing delay settings ======
      delay: 800,
      delayTimer: null,
      // ===================================

      interval: 1,
      rate: 1,
      inputMiles: 0,
      selectedMiles: 0,
      sliderOptions: {
        lazy: true,
        duration: null,
        height: 10,
        contained: true,
      },
      minValue: 0,
      maxValue: 0,
      miles: 0,
      minimumMiles: 0,

      redeemMilesEnabled: false,
      milesNBonusLoggedIn: false,

      cardImage: null,
      mbDictionary: {},
      milesNBonusLogo: null,
      lang: 'en',
      id: '',

      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    }
  },

  computed: {
    formatedMaxValue() {
      if (this.totalCost * this.rate > this.miles) {
        return this.miles - (this.miles % this.interval)
      }
      return Math.round(this.totalCost * this.rate)
    },
    discountAmount() {
      return this.selectedMiles / this.rate
    },

    remainingAmount() {
      return this.totalCost - this.selectedMiles / this.rate
    },

    minimumMilesRule() {
      let value = 0
      if (typeof this.inputMiles === 'string') {
        value = Number(this.inputMiles.replaceAll(',', '').replaceAll('.', ''))
      } else {
        value = this.inputMiles
      }

      return !(value >= 1500)
    },

    maximumMilesRule() {
      let value = 0
      if (typeof this.inputMiles === 'string') {
        value = Number(this.inputMiles.replaceAll(',', '').replaceAll('.', ''))
      } else {
        value = this.inputMiles
      }
      return !(value <= this.formatedMaxValue)
    },
    sameMinMax() {
      if (this.minValue === this.formatedMaxValue) {
        return true
      }
      return false
    },
  },
  watch: {
    milesNBonusLoggedIn() {
      this.$nextTick(() => {
        this.inputMilesCleve()
      })
    },
  },

  mounted() {
    this.lang = lib.getLocaleFromLangAttr()
    if (lib.getData('milesNBonusData')) {
      const { dictionary, configuration, milesNBonusLogo, milesNBonusAccount } =
        lib.getData('milesNBonusData')
      this.mbDictionary = dictionary
      this.milesNBonusLoggedIn = configuration.milesNBonusLoggedIn
      this.rate = configuration.rate
      this.milesNBonusLogo = milesNBonusLogo
      this.miles = this.maxValue = milesNBonusAccount.miles
      this.cardImage = milesNBonusAccount.cardImage
      this.id = milesNBonusAccount.id
      // this.interval = configuration.rate / 100
      this.minimumMiles = configuration.minimumMiles

      this.setDefaultValues()
      this.setEventListeners()

      this.$nextTick(() => {
        this.inputMilesCleve()
      })
    }
  },
  methods: {
    setDefaultValues() {
      // if (this.minimumMiles % this.interval > 0) {
      //   console.log(0)
      //   this.selectedMiles = this.minValue =
      //     this.minimumMiles -
      //     (this.minimumMiles % this.interval) +
      //     this.interval

      //   this.inputMiles = (
      //     this.minimumMiles -
      //     (this.minimumMiles % this.interval) +
      //     this.interval
      //   ).toLocaleString(this.lang)
      // } else {

      //   this.selectedMiles = this.minValue = this.minimumMiles
      //   this.inputMiles = this.minimumMiles.toLocaleString(this.lang)
      // }

      this.minValue = this.minimumMiles
      this.maxValue = this.formatedMaxValue
      this.selectedMiles = this.maxValue
      this.inputMiles = this.maxValue.toLocaleString(this.lang)
    },

    setEventListeners() {
      document.addEventListener('milesNBonusLogStatus', (e) => {
        this.milesNBonusLoggedIn = e.detail.logStatus
        this.miles = e.detail.miles
      })
      document.addEventListener('updatedMBValues', (e) => {
        const data = e.detail.data
        this.id = data.milesNBonusAccount.id
        this.miles = this.maxValue = data.milesNBonusAccount.miles
        this.cardImage = data.milesNBonusAccount.cardImage
        this.rate = data.rate
        this.minimumMiles = data.minimumMiles

        this.setDefaultValues()
        this.$nextTick(() => {
          this.inputMilesCleve()
        })
      })
    },

    getDecimalMark() {
      return (0.1).toLocaleString(this.lang).substring(1, 2)
    },

    getThousandMark() {
      return (1000).toLocaleString(this.lang).substring(1, 2)
    },

    inputMilesCleve() {
      if (!document.getElementById('inputMiles')) {
        return
      }

      new Cleave('#inputMiles', {
        numeral: true,
        numeralDecimalScale: 0,
        numeralDecimalMark: this.getDecimalMark(),
        delimiter: this.getThousandMark(),
        onValueChanged: (e) => {
          clearTimeout(this.delayTimer)
          this.delayTimer = setTimeout(() => {
            const newValue = e.target
            this.inputMiles = newValue.value

            // if (newValue.rawValue > this.formatedMaxValue) {
            //   // this.selectedMiles = this.formatedMaxValue
            //   // this.inputMiles = this.formatedMaxValue.toLocaleString(this.lang)
            //   console.log('high miles')
            // } else if (newValue.rawValue < this.minValue) {
            //   // this.selectedMiles = this.minValue
            //   // this.inputMiles = this.minValue.toLocaleString(this.lang)
            //   console.log('low miles')
            // }
            if (
              !(newValue.rawValue > this.formatedMaxValue) &&
              !(newValue.rawValue < this.minValue)
            ) {
              this.selectedMiles =
                Number(newValue.rawValue) -
                (Number(newValue.rawValue) % this.interval)
              this.inputMiles = newValue.value
            }
          }, this.delay)
        },
      })
    },

    showLoginModal() {
      document.dispatchEvent(new CustomEvent('showMilesNBonusModal'))
    },

    onClickCancel() {
      this.toggleMiles()

      this.selectedMiles = this.inputMiles = this.formatedMaxValue

      this.$nextTick(() => {
        this.inputMilesCleve()
      })
    },

    onClickSubmit() {
      this.toggleMiles()
    },

    toggleMiles() {
      this.redeemMilesEnabled = !this.redeemMilesEnabled
      this.$emit('has-balance-due', this.redeemMilesEnabled, {
        redeemedMiles: this.selectedMiles,
        discountAmount: this.discountAmount,
        remainingAmount: this.remainingAmount,
      })
    },

    sliderPlus() {
      const temp = (this.selectedMiles += this.interval)
      if (this.formatedMaxValue <= temp) {
        this.selectedMiles = this.formatedMaxValue
      } else {
        this.selectedMiles = temp
      }
      this.onChange()
    },

    sliderMinus() {
      const temp = (this.selectedMiles -= this.interval)
      if (this.minValue > temp) {
        this.selectedMiles = this.minValue
      } else {
        this.selectedMiles = temp
      }
      this.onChange()
    },

    onChange() {
      // do not remove $nextTick
      this.$nextTick(() => {
        this.inputMiles = this.selectedMiles.toLocaleString(this.lang)
      })
    },
  },
}
</script>
